export * from './lib/medrecord-translation.loader';
export * from './lib/translation-loader.interface';
export * from './lib/translation-loader-config.interface';